<template>
	<form @submit.prevent="change" class="expression">
		<p class="expression__noti">
			해당 제품에 매핑된 표현식은 달파 ai로 분석된 데이터입니다. 따라서
			제품에 매핑된 표현식만 노출 / 비노출 설정이 가능합니다.
		</p>
		<div v-if="hasData" class="expression__cont">
			<div class="expression__wrap">
				<ExpressionSection
					title="좋았어요"
					:data="posData"
					v-model="checkedList"
				/>
				<ExpressionSection
					title="아쉬워요"
					:data="negData"
					v-model="checkedList"
				/>
			</div>
		</div>
		<div v-else>
			<p class="expression__no">데이터가 없습니다</p>
		</div>
		<div class="btn-wrap">
			<button v-if="hasData" class="btn-main blue" type="submit">
				수정
			</button>
			<button class="btn-main blue bordered" type="button" @click="close">
				닫기
			</button>
		</div>
	</form>
</template>
<script>
	import { mapState } from 'vuex';
	import ExpressionSection from './ExpressionSection.vue';

	export default {
		components: {
			ExpressionSection,
		},

		data() {
			return {
				checkedList: [],
			};
		},
		computed: {
			...mapState({ params: state => state.modal.params }),
			hasData() {
				return this.posData.length > 0 || this.negData.length > 0;
			},
			posData() {
				return this.params.data.pos;
			},
			negData() {
				return this.params.data.neg;
			},
		},
		mounted() {
			this.initializeCheckedList();
		},
		methods: {
			initializeCheckedList() {
				this.checkedList = [
					...this.posData
						.filter(item => item.isDisplay)
						.map(item => item.productExpressionId),
					...this.negData
						.filter(item => item.isDisplay)
						.map(item => item.productExpressionId),
				];
			},
			getDisplayList() {
				return [...this.posData, ...this.negData].map(item => ({
					id: item.productExpressionId,
					isDisplay: this.checkedList.includes(
						item.productExpressionId
					),
				}));
			},
			async change() {
				try {
					const params = {
						dalphaIsDisplayItems: this.getDisplayList(),
					};
					await this.$axiosAdmin2.put(
						`/api/dalpha/expression/isDisplay/multi?idProduct=${this.$route.params.idProduct}`,
						params
					);
					alert('수정이 완료되었습니다.');
					this.close();
				} catch (error) {
					console.error(error);
					alert(
						'수정에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의해주세요.'
					);
				}
			},
			close() {
				this.$store.commit('modal/toggleModal', false);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.expression {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		&__noti {
			font-size: 15px;
			color: #797979;
			font-style: italic;
			margin: 20px 0;
		}

		&__all {
			display: flex;
			align-items: center;
			gap: 5px;
			margin-bottom: 10px;
			border-bottom: 1px solid #e3e3e3;
			padding-bottom: 10px;
			font-size: 15px;
		}

		&__cont {
			border-bottom: 1px solid #e3e3e3;
			margin-bottom: 20px;
		}
		&__wrap {
			display: flex;
			justify-content: space-between;
			margin: 20px;
			gap: 10px;
		}

		&__box {
			width: 50%;
			display: flex;
			flex-direction: column;
			gap: 20px;
		}

		&__text {
			font-size: 15px;
			font-weight: bold;
			padding: 10px;
			border-radius: 15px;
			background-color: #e3e3e3;
		}

		&__no {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 400px;
			font-size: 20px;
			color: #c0c0c0;
			font-style: italic;
		}
	}
</style>
